import { CampusWard } from './campus-ward.model';
import { CampusStake } from './campus-stake.model';
import { WardMeeting } from './ward-meeting.model';
import { LocalWard } from './local-ward.model';
import { WardLeader } from './ward-leader.model';

export class CampusWardDetails extends CampusWard {
  bishopOffice: string;
  phone: string;
  email: string;
  modifiedBy: string;
  modifiedOn?: Date;
  campusStake: CampusStake;
  meetings: WardMeeting[];
  localWards: LocalWard[];
  bishop: WardLeader;
  firstCounselor: WardLeader;
  secondCounselor: WardLeader;
}
